import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { IconService } from '../../../services/icon.service';

@Component({
    selector: 'nuc-icon',
    imports: [MatIcon],
    templateUrl: './icon.component.html',
    styleUrl: './icon.component.scss'
})
export class IconComponent {
  @Input() displayClass: string;
  @Input() iconClass: string;
  @Input() color: string;
  @Input() size: string;
  @Input() disabled: boolean;
  @Input() iconSrc: string = ''; // API URL for the SVG
  @Input() dataAueResource?: string;
 
  constructor(private iconService: IconService) {
    //this constructor is MUST although iconService is not being used.
    //we need iconService to be initialised.
  }
}
